import { AiFounderGithubDigestArticle } from '@/components/ai-founder-github-digest/ai-founder-github-digest-article'
import { Container } from '@/components/container'
import { Footer } from '@/components/footer'
import { Navbar } from '@/components/navbar'
import { Head } from '@inertiajs/react'

const TITLE = 'AI Founder GitHub Digest for What Shipped'
const DESCRIPTION =
  'A founder GitHub digest is a daily or weekly summary of commits from selected repositories, sent to Slack and email so founders see what shipped.'

type Faq = {
  question: string
  answer: string
}

type Props = {
  headline: string
  faqs: Faq[]
}

export default function AiFounderGithubDigestShow({ headline, faqs }: Props) {
  return (
    <>
      <Head title={TITLE}>
        <meta head-key="description" name="description" content={DESCRIPTION} />
      </Head>
      <div className="flex min-h-screen flex-col">
        <main className="flex-1 overflow-hidden">
          <Container>
            <Navbar />
          </Container>
          <div className="from-background via-feature-subtle/50 to-muted/20 min-h-100vh bg-gradient-to-b">
            <Container className="py-16 md:py-24">
              <AiFounderGithubDigestArticle headline={headline} faqs={faqs} />
            </Container>
          </div>
        </main>
        <Footer />
      </div>
    </>
  )
}
